import {AfterViewInit, Component, Inject, OnInit, Pipe, PipeTransform, ViewChild} from '@angular/core';
import {UserPrivilegeService} from '../../../../services/common/user-privilege/user-privilege.service';
import {AcDialog, DIALOG_CONFIG} from 'ac-infra';
import {ENTER, SPACE} from '@angular/cdk/keycodes';
import {Subject} from 'rxjs';
import {MatChipInputEvent} from '@angular/material/chips';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {Clipboard} from '@angular/cdk/clipboard';
import {NgForm} from '@angular/forms';


@Pipe({name: 'prefixesSearchFilter'})
export class SearchFilterPipe implements PipeTransform {
  transform(items: any[], searchString: string): any[] {
    if (!items) {
      return [];
    }
    if (!searchString || searchString === '') {
      return items.slice(0, 200);
    }
    return items.filter(it => it.includes(searchString)).slice(0, 200);
  }
}

@Pipe({name: 'totalPrefixesSearchFilter'})
export class SearchTotalFilterPipe implements PipeTransform {
  transform(items: any[], searchString: string): number {
    if (!items) {
      return 0;
    }
    if (!searchString || searchString === '') {
      return items.length;
    }
    return items.filter(it => it.includes(searchString)).length;
  }
}

@AcDialog({
  width: 700
})
@Component({
  selector: 'prefix-groups-dialog',
  templateUrl: './prefix-groups-dialog.component.html',
  styleUrls: ['./prefix-groups-dialog.component.scss']
})
export class PrefixGroupsDialogComponent implements OnInit, AfterViewInit {

  isEditMode: boolean;
  prefixGroup: any;
  prefixTypeOptions: any;
  separatorKeysCodes: number[] = [ENTER, SPACE];
  modelChanged: Subject<string> = new Subject<string>();
  copyToClipboardTooltipContent = 'Copy all prefixes to clipboard';
  searchValue = '';
  model: string;

  @ViewChild('prefixForm') prefixForm: NgForm;

  constructor(private userPrivilege: UserPrivilegeService,
              @Inject(DIALOG_CONFIG) private dialogConfig,
              private clipboard: Clipboard) {
    this.prefixGroup = dialogConfig.dialogData.selectedItem;
    this.prefixTypeOptions = dialogConfig.dialogData.prefixTypeOptions;
    this.isEditMode = dialogConfig.dialogData.isEditMode;
    dialogConfig.submitButtonDisabled = true;
  }

  ngOnInit(): void {
    this.modelChanged.pipe(
      debounceTime(300),
      distinctUntilChanged())
      .subscribe(model => this.searchValue = model);
  }

  ngAfterViewInit(): void {
    this.prefixForm.form.statusChanges.subscribe(() => {
      this.updateSubmitDisabled();
    });
  }

  setDefaultCopyToClipboardTooltip(): void {
    setTimeout(() => {
      this.copyToClipboardTooltipContent = 'Copy all prefixes to clipboard';
    }, 500);
  }

  copyPrefixesToClipboard(): void {
    const copy = this.clipboard.beginCopy(this.prefixGroup.values.join('\n'));

    const attemptToCopy = () => {
      if (copy.copy()) {
        this.copyToClipboardTooltipContent = 'Copied';
        copy.destroy();
      } else {
        this.copyToClipboardTooltipContent = 'Copy failed';
      }
    };

    attemptToCopy();
  }

  clearPrefixes(): void {
    this.prefixGroup.values = [];
    this.updateSubmitDisabled();
  }

  paste(event: ClipboardEvent): void {
    event.preventDefault();
    event.clipboardData
      .getData('Text')
      .split(/\s|\n/)
      .forEach(value => {
        if (value.trim()) {
          if (!this.prefixGroup.values.includes(value)) {
            this.prefixGroup.values.push(value.trim());
          }
        }
      });
    this.prefixGroup.values = this.prefixGroup.values.concat([]);
    this.updateSubmitDisabled();
  }

  addPrefixValue(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    if ((value || '').trim()) {
      if (!this.prefixGroup.values.includes(value)) {
        this.prefixGroup.values.push(value);
        input.value = '';   // Reset the input value
      }
    }
    this.prefixGroup.values = this.prefixGroup.values.concat([]);
    this.updateSubmitDisabled();
  }

  removePrefixValue(chip: any): void {
    const index = this.prefixGroup.values.indexOf(chip);

    if (index >= 0) {
      this.prefixGroup.values.splice(index, 1);
    }
    this.prefixGroup.values = this.prefixGroup.values.concat([]);
    this.updateSubmitDisabled();
  }

  searchChanged(text: string): void {
    this.modelChanged.next(text);
  }

  clearSearch(): void {
    this.searchValue = '';
    this.model = '';
  }


  private updateSubmitDisabled(): void {
    this.dialogConfig.submitButtonDisabled = !this.prefixForm.form.valid || this.prefixGroup.values.length === 0;
  }
}
